import { useTranslate } from "@similarweb/i18n-provider";
import { Button, EmptyState } from "@similarweb/ui-components";

type Props = {
    onRetry: () => void;
    dataAutomation: string;
};

export const ScoringBoardError = ({ onRetry, dataAutomation }: Props) => {
    const { translate } = useTranslate();

    return (
        <EmptyState
            title={translate("common.error")}
            subtitle={translate("si.common.error.reload")}
            iconName="no-data-tree"
            CtaButtons={() => (
                <Button
                    type="primary"
                    onClick={onRetry}
                    dataAutomation={dataAutomation}
                >
                    {translate("si.common.refresh")}
                </Button>
            )}
        />
    );
};
